export default __webpack_public_path__ + "static/media/Round_product.4f69f450.png";